'use client'

import { useLayoutEffect, useRef, useState } from 'react'

import { useTranslation } from '@/hooks/client/use-translation'
import { tw } from '@/lib/utils'

interface ExpandableDescriptionProps {
  text: string
}

export const ExpandableDescription = ({ text }: ExpandableDescriptionProps) => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)
  const ref = useRef<HTMLParagraphElement>(null)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    // Check if text overflows when clamped to 3 lines
    setIsTruncated(el.scrollHeight > el.clientHeight + 1)
  }, [text])

  return (
    <div>
      <p ref={ref} className={tw('text-navy/70 text-sm leading-relaxed', !expanded && 'line-clamp-2')}>
        {text}
      </p>
      {isTruncated ? (
        <button
          type="button"
          data-tracking="ignore"
          aria-expanded={expanded}
          onClick={() => setExpanded(!expanded)}
          className="text-lapis mt-0.5 cursor-pointer text-sm font-medium hover:underline"
        >
          {expanded ? t('compare.less', 'less') : t('compare.more', 'more')}
        </button>
      ) : null}
    </div>
  )
}
